import { render, staticRenderFns } from "./BnGapHibaCard.vue?vue&type=template&id=fcfb8396&scoped=true&"
import script from "./BnGapHibaCard.vue?vue&type=script&lang=js&"
export * from "./BnGapHibaCard.vue?vue&type=script&lang=js&"
import style0 from "./BnGapHibaCard.vue?vue&type=style&index=0&id=fcfb8396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfb8396",
  null
  
)

export default component.exports